export default {
    apiKey: "AIzaSyDqXdoPZQh0oQqHWIiPSKWo1_yQkX3uggY",
    authDomain: "stras-45a96.firebaseapp.com",
    databaseURL: "https://stras-45a96.firebaseio.com",
    projectId: "stras-45a96",
    storageBucket: "stras-45a96.appspot.com",
    messagingSenderId: "235573024135",
    appId: "1:235573024135:web:9507db9103aec611d9af22",
    measurementId: "G-04C5H58RRY"
}